import { useMemo } from "react";
import { Link, useLocation } from "react-router";

import { useDocumentTitle } from "../../../../use-document-title";
import { useSecondaryHeader } from "../../../../secondary-header-context";
import { useFilteredWorkflowStatusHistory } from "../../../../workflow-history-api";
import { isWorkflowHistoryWarming } from "../../../../workflow-history-state";
import { WorkflowHistoryChart } from "../workflow-history-chart";
import { WorkflowHistoryFilterControls } from "../workflow-history-filter-controls";
import { useWorkflowQueryState } from "../../../../workflow-query-state";
import styles from "./history.module.css";

const PAGE_NAV = [
  { href: "/workflows", label: "Overview" },
  { href: "/workflows/runs", label: "Runs" },
  { href: "/workflows/history", label: "History" },
  { href: "/workflows/definitions", label: "Definitions" },
];

export function WorkflowHistoryPage() {
  useDocumentTitle("Workflow status history");
  const location = useLocation();
  const { filters, setFilters } = useWorkflowQueryState();
  const history = useFilteredWorkflowStatusHistory(filters);

  const secondaryHeader = useMemo(() => (
    <div className={styles.secondaryHeader}>
      <nav className={styles.pageNav} aria-label="Workflow pages">
        {PAGE_NAV.map((item) => (
          <Link
            key={item.href}
            to={`${item.href}${location.search}`}
            className={`${styles.pageNavLink} ${item.href === "/workflows/history" ? styles.pageNavLinkActive : ""}`}
          >
            {item.label}
          </Link>
        ))}
      </nav>
      <div className={styles.filterControls}>
        <WorkflowHistoryFilterControls
          filters={filters}
          asOf={history.data?.asOf}
          onFiltersChange={setFilters}
        />
      </div>
    </div>
  ), [filters, history.data?.asOf, location.search, setFilters]);
  useSecondaryHeader(secondaryHeader);

  return (
    <div className={styles.page}>
      <WorkflowHistoryChart
        className={styles.chart}
        maximised
        showPeriodControls={false}
        points={history.data?.points ?? []}
        period={filters.period}
        onPeriodChange={(period) => setFilters({ period, from: "", to: "" })}
        loading={history.isLoading}
        error={history.isError}
        warming={isWorkflowHistoryWarming(history.data)}
        asOf={history.data?.asOf}
      />
    </div>
  );
}
